module.exports = __webpack_public_path__ + "static/media/product27.f6e61049.jpg";